import { req, jccReq } from '@/utils/request'

//  用户注册服务协议 
export function getAgreementByType (type) {
    return req({ //需要loading加载
        url: `/app/feedback/getAgreement?typeId=${type}`,
        method: 'get'
    })
}

//  聚充充B端公众号授权
export function getMpOpenId (data) {
    return jccReq({ //需要loading加载
        url: `/obama/ossUser/v1/getOpenID`,
        method: 'post',
        data
    })
}